import React from "react";
import Modal from "./Modal";

// Dialogo para el 409 APPOINTMENT_ALREADY_CHARGED.
//
// 🔴 Mismo patron que OverlapConfirmDialog (Bloque 2B-2): un error del motor se convierte en
//    una DECISION con dos caminos, no en un mensaje muerto. Aqui el motor es el indice
//    `idx_cobros_appt_vivo`, que impide dos cobros vivos para la misma cita.
//
// El `detail` viene tal cual del backend y NO se reescribe. Lo que aporta esta pantalla es la
// accion siguiente -- abrir el cobro que ya existe -- que el backend no puede saber.
//
// "Ver el cobro existente" ES el camino feliz y lleva el estilo destacado: si la cita ya esta
// cobrada, lo normal es querer verlo, no insistir.
export default function CobroExistenteDialog({ open, detail, onCerrar, onVerCobro }) {
  return (
    <Modal
      open={open}
      onClose={onCerrar}
      title="Esta cita ya tiene un cobro"
      size="sm"
      testid="modal-cobro-existente"
      footer={
        <>
          <button
            type="button"
            onClick={onCerrar}
            className="px-4 py-2 text-sm rounded-lg border border-slate-300 text-slate-600 hover:bg-slate-50"
            data-testid="cobro-existente-cerrar"
          >
            Cerrar
          </button>
          <button
            type="button"
            onClick={onVerCobro}
            className="px-4 py-2 text-sm rounded-lg bg-brand-electric text-white hover:bg-blue-700"
            data-testid="cobro-existente-ver"
          >
            Ver el cobro
          </button>
        </>
      }
    >
      <p className="text-sm text-slate-700">{detail}</p>
      <p className="text-xs text-slate-500 mt-3">
        Si necesitas rehacerlo, anula el cobro existente: al anularlo, la cita queda libre para
        cobrarse de nuevo.
      </p>
    </Modal>
  );
}
